module.exports = __webpack_public_path__ + "static/media/headlight-dark.2ed43849.svg";